"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactBlueprintLibrary = require("react-blueprint-library");
var _utils = require("../../utils");
var _lodash = require("lodash");
var _imageSrc = require("../../lib/imageSrc");
var _richTextField = require("../../lib/richTextField");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
/**
 *  A react component to create a Contact Modal
 *
 * @param {object} props The properties passed into the object
 * @param {object} props.rendering.fields Fields for rendering
 *
 * @returns {React.ReactElement} A Contact Modal
 */
var ContactModal = props => {
  var extractedFields = (0, _utils.extractFieldsFn)(props);
  var [show, setShow] = (0, _react.useState)(false);
  var handleShow = () => setShow(true);
  var handleHide = () => setShow(false);
  var nameCombo = (0, _lodash.kebabCase)(extractedFields.FirstName.value + extractedFields.LastName.value);
  var parsedBio = (0, _richTextField.parseHTML)(extractedFields.BioDescription);
  var newBio = '';
  var MoreBtn = /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Button, {
    variant: 'link',
    onClick: handleShow,
    className: "btn-inline",
    id: "more-link-".concat(nameCombo)
  }, "More");
  if (Array.isArray(parsedBio)) {
    var {
      result,
      fullSentence
    } = (0, _richTextField.subStringHTML)(parsedBio, 136);
    newBio = result;
    if (fullSentence.length > 136) {
      var lastIndex = (0, _lodash.findLastIndex)(result);
      if ((0, _lodash.isObject)(newBio[lastIndex])) {
        newBio[lastIndex].props.children = newBio[lastIndex].props.children.concat('... ');
      } else {
        newBio[lastIndex] = newBio[lastIndex].concat('... ');
      }
    }
    newBio.push(MoreBtn);
  } else {
    if (parsedBio.length < 137) {
      newBio = parsedBio;
    } else {
      newBio = parsedBio.substring(0, 136);
      newBio = newBio.concat('... ');
    }
  }
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("h3", null, props.showSideTitle === true ? extractedFields.SideBarCardTitle.value : extractedFields.ContactCardTitle.value), /*#__PURE__*/_react.default.createElement("picture", {
    className: "mm-img-circle--xl"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: (0, _imageSrc.imageHref)(extractedFields.ContactImage.value),
    alt: extractedFields.ContactImage.value.alt
  })), /*#__PURE__*/_react.default.createElement("h4", null, extractedFields.FirstName.value, "\xA0", extractedFields.LastName.value, "\xA0", extractedFields.NameSuffix.value), /*#__PURE__*/_react.default.createElement("p", null, extractedFields.JobTitle.value), /*#__PURE__*/_react.default.createElement("h4", null, extractedFields.OfficeName.value), /*#__PURE__*/_react.default.createElement("div", null, Array.isArray(parsedBio) ? newBio : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, newBio, MoreBtn)), !(0, _lodash.isEmpty)(extractedFields.EmailAddress.value) && /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("span", {
    className: "icon-email icon-sm"
  }), "\xA0", /*#__PURE__*/_react.default.createElement("a", {
    id: "email-".concat(nameCombo),
    href: "mailto:".concat(extractedFields.EmailAddress.value)
  }, "Send Email")), /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Modal, {
    show: show,
    onHide: handleHide,
    backdrop: true,
    size: "md"
  }, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Modal.Header, {
    onClose: handleHide
  }), /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Modal.Body, null, /*#__PURE__*/_react.default.createElement("h3", null, extractedFields.FirstName.value, "\xA0", extractedFields.LastName.value, "\xA0"), /*#__PURE__*/_react.default.createElement("picture", {
    className: "mm-img-circle--xl"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: (0, _imageSrc.imageHref)(extractedFields.ContactImage.value),
    alt: extractedFields.ContactImage.value.alt
  })), /*#__PURE__*/_react.default.createElement("h4", null, extractedFields.FirstName.value, "\xA0", extractedFields.LastName.value, "\xA0", extractedFields.NameSuffix.value), /*#__PURE__*/_react.default.createElement("p", null, extractedFields.JobTitle.value), /*#__PURE__*/_react.default.createElement("h4", null, extractedFields.OfficeName.value), /*#__PURE__*/_react.default.createElement("div", null, parsedBio), /*#__PURE__*/_react.default.createElement("p", null, !(0, _lodash.isEmpty)(extractedFields.EmailAddress.value) && /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("span", {
    className: "icon-email icon-sm"
  }), "\xA0", /*#__PURE__*/_react.default.createElement("a", {
    id: "email-".concat(nameCombo),
    href: "mailto:".concat(extractedFields.EmailAddress.value)
  }, "Send Email"))))));
};
var _default = exports.default = ContactModal;